export const appSettingsAppGroupIdMessagePrioritizationHasFrequencyCappingRules =
  "/app_settings/:app_group_id/message_prioritization/has_frequency_capping_rules";
